module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event_raiten-ca5e0a7a65c1a39e15ff8324432565c1.jpg";